
$(function () {
    $(".widget-html-editor .editor-tabs a.tab").click(function () {
        var selected = $(this).hasClass("selected");
        var tab = $(this).data("tab");

        if (!selected) {
            $(this).parent().children("a.tab").removeClass("selected");
            $(this).parent().parent().children(".content").removeClass("selected");

            $(this).addClass("selected");
            $(this).parent().parent().children(".content[data-tab=" + tab + "]").addClass("selected");

            if (tab === "preview") {
                $(this).parent().parent().children(".content[data-tab=preview]")
                    .html("<div class='loading'>...Generating preview...</div>");
                var markdown = $(this).parent().parent().find("textarea").val();
                var _self = this;

                $.ajax({
                    url: "/markdown/parse",
                    method: "POST",
                    contentType: "application/json",
                    cache: false,
                    data: JSON.stringify({ markdown: markdown }),
                    success: function (d) {
                        $(_self).parent().parent().children(".content[data-tab=preview]").html(d);
                    },
                    error: function (x, s, e) {
                        $(this).parent().parent().children(".content[data-tab=preview]").html(markdown);
                    }
                });
            }
        }
    });
})